export default "__VITE_ASSET__DQW85oz1__"